import styled, {css} from 'styled-components';

import type {StyledTooltipContentProps, StyledTooltipContentArrowProps} from './typings';

import zIndex from '@/theme/constants/zIndex';
import colors from '@/theme/constants/colors';
import pxToRem from '@/theme/helpers/pxToRem';
import typography from '@/theme/typography';

export const StyledTooltipContent = styled.div<StyledTooltipContentProps>`
  position: fixed;
  pointer-events: none;
  z-index: ${zIndex.tooltip};
  padding: ${pxToRem(14)} ${pxToRem(18)};
  ${typography.Body2}
  color: ${colors.white};
  max-width: 270px;
  white-space: pre-line;
  width: max-content;
  background: ${colors.darkBlue100};
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: ${({$isVisible}) => ($isVisible ? 1 : 0)};
  transform: ${({$isVisible, $placement}) =>
    $isVisible
      ? 'translateY(0)'
      : $placement === 'top'
        ? 'translateY(10px)'
        : $placement === 'bottom'
          ? 'translateY(-10px)'
          : $placement === 'left'
            ? 'translateX(10px)'
            : 'translateX(-10px)'};
  transition:
    opacity 0.2s ease,
    transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
`;

export const StyledTooltipContentArrow = styled.span<StyledTooltipContentArrowProps>`
  position: absolute;
  width: 0;
  height: 0;

  ${({$placement}) => {
    switch ($placement) {
      case 'top':
        return css`
          border-left: 7px solid transparent;
          border-right: 7px solid transparent;
          border-top: 5px solid rgba(0, 0, 0, 0.9);
          bottom: -5px;
          left: 50%;
          transform: translateX(-50%);
        `;
      case 'bottom':
        return css`
          border-left: 7px solid transparent;
          border-right: 7px solid transparent;
          border-bottom: 5px solid rgba(0, 0, 0, 0.9);
          top: -5px;
          left: 50%;
          transform: translateX(-50%);
        `;
      case 'left':
        return css`
          border-top: 7px solid transparent;
          border-bottom: 7px solid transparent;
          border-left: 5px solid rgba(0, 0, 0, 0.9);
          right: -5px;
          top: 50%;
          transform: translateY(-50%);
        `;
      case 'right':
        return css`
          border-top: 7px solid transparent;
          border-bottom: 7px solid transparent;
          border-right: 5px solid rgba(0, 0, 0, 0.9);
          left: -4px; /* instead of -5px */
          top: 50%;
          transform: translateY(-50%);
        `;
      default:
        return css`
          border-left: 7px solid transparent;
          border-right: 7px solid transparent;
          border-top: 5px solid rgba(0, 0, 0, 0.9);
          bottom: -5px;
          left: 50%;
          transform: translateX(-50%);
        `;
    }
  }}
`;
